import { render, staticRenderFns } from "./WarehouseImportsTable.vue?vue&type=template&id=6ba2bd42&"
import script from "./WarehouseImportsTable.vue?vue&type=script&lang=ts&"
export * from "./WarehouseImportsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports